module.exports = __webpack_public_path__ + "img/swiperimg0.33571a82.jpg";